import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class OngsListController {
  constructor() {
  }

  isEmpty() {
    return isUndefinedOrNullOrEmpty(this.ongs) && this.isLoaded;
  }
}

export default OngsListController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongsList.controller.js